import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { formatDate } from '../../../shared/utils/date';
import { I18N } from '../../../constants';
import SmallLoader from '../../../components/SmallLoader';
import { renderPaginationShowsTotal } from '../../../shared/utils/table';

export default class RunsTable extends React.Component {
    render() {
        const { runs, isFetching, onRunClick, sortName, sortOrder } = this.props;

        const options = {
            onRowClick: onRunClick,
            sizePerPageList: [10, 25, 50, 100],
            prePage: 'Prev',
            nextPage: 'Next',
            firstPage: 'First',
            lastPage: 'Last',
            paginationShowsTotal: renderPaginationShowsTotal,
            defaultSortName: sortName,
            defaultSortOrder: sortOrder,
            noDataText: isFetching ? (
                <SmallLoader />
            ) : (
                'No data to display. Please refine your search.'
            ),
        };

        return (
            <BootstrapTable data={runs} options={options} pagination hover trClassName="clickable">
                <TableHeaderColumn dataField="runId" isKey dataSort width="400" hidden>
                    Route ID
                </TableHeaderColumn>
                <TableHeaderColumn dataField="routeCode" dataSort width="300">
                    Route code
                </TableHeaderColumn>
                <TableHeaderColumn dataField="runSequence" dataSort width="100">
                    Run seq.
                </TableHeaderColumn>
                <TableHeaderColumn dataField="runDate" dataFormat={formatDate} dataSort width="200">
                    Run date
                </TableHeaderColumn>
                <TableHeaderColumn dataField="logisticPartner" width="160" dataSort>
                    Logistic partner
                </TableHeaderColumn>
                <TableHeaderColumn dataField="etaFinalPoint" width="200">
                    Planned arrival
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="runStatus"
                    dataFormat={status => I18N.RUN_STATUS[status]}
                    dataSort
                    width="200"
                >
                    Run status
                </TableHeaderColumn>
            </BootstrapTable>
        );
    }
}
